
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage";
import { collection, getDocs, getDoc, query, where, doc, setDoc, addDoc, QuerySnapshot, CollectionReference } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAyCD-wfzTUAucyPbrypYtnOz9pc553wno",
  authDomain: "profile-beb01.firebaseapp.com",
  databaseURL: "https://profile-beb01-default-rtdb.firebaseio.com",
  projectId: "profile-beb01",
  storageBucket: "profile-beb01.appspot.com",
  messagingSenderId: "1086558373551",
  appId: "1:1086558373551:web:01f69d96909e8b7763365a",
  measurementId: "G-H74LK9KKMV"
};



const app = initializeApp(firebaseConfig);

const storage = getStorage(app);

export const db = getFirestore(app);

export { storage, app };


export async function addabout(about) {
  await addDoc(collection(db, 'About'), about)
}

export async function getAbout() {
  const q = query(collection(db, 'About'))
  const snap = await getDocs(q)
  var res = snap.docs.map(doc => doc.data())
  console.log(res)
  return res
}

export async function addhome(home) {
  await addDoc(collection(db, 'Home'), home)
}

export async function addProject(project) {
  await addDoc(collection(db, 'Project'), project)
}

export async function addMemory(mem){
  await addDoc(collection(db, 'Memory'), mem)
}

export async function getAllMemory(){
  const q = query(collection(db, 'Memory'))
  const snap = await getDocs(q)
  var res = snap.docs.map(doc => doc.data())
  return res
}

export async function getHome() {
  const q = query(collection(db, 'Home'))
  const snap = await getDocs(q)
  var res = snap.docs.map(doc => doc.data())
  console.log(res)
  return res;
}

export async function getAllLanguage() {
  const qr = query(collection(db, 'Language'));
  const snap = await getDocs(qr)
  var res = snap.docs.map(doc => doc.data())
  console.log(res)

  return res
}


export async function getAllDatabase() {
  const qr = query(collection(db, 'Database'));
  const snap = await getDocs(qr)
  var res = snap.docs.map(doc => doc.data())
  console.log(res)

  return res
}


export async function getAllPosition() {
  const qr = query(collection(db, 'Position'));
  const snap = await getDocs(qr)
  var res = snap.docs.map(doc => doc.data())
  console.log(res)

  return res
}


export async function getAllProject(){
  const qr = query(collection(db, 'Project'));
  const snap = await getDocs(qr);
  const res = snap.docs.map(doc => doc.data());
  console.log(res)

  return res;
}


